import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { SidebarModalBlockComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import { MarginComponent } from 'design/margin';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';
import { PartnerClientMonthReport } from 'types/partnerClientManagerTypes';

type Props = {
  monthReports: PartnerClientMonthReport[];
};

export const PartnerClientManagerPayments = (props: Props) => {
  const { monthReports } = props;

  const {
    partnerClientManager: { clientMonthReportTable: ownDictionary },
    shared: sharedDictionary,
  } = useIntlDictionary();

  return (
    <>
      {monthReports.length === 0 && (
        <SidebarModalBlockComponent>
          <TextComponent>{ownDictionary.fallbackText}</TextComponent>
        </SidebarModalBlockComponent>
      )}
      {monthReports.map((monthReport) => (
        <SidebarModalBlockComponent withBorder>
          <TextComponent size="mp" weight="medium">
            {ownDictionary.titleText(monthReport.period)}
          </TextComponent>
          <MarginComponent top={20} />
          <SmallTableWrapperComponent>
            <SmallTableRowComponent>
              <TextComponent>{ownDictionary.startDateLabelText}</TextComponent>
              <TextComponent>
                {ownDictionary.startDateText(monthReport.period)}
              </TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>{ownDictionary.endDateLabelText}</TextComponent>
              <TextComponent>
                {ownDictionary.endDateText(monthReport.period)}
              </TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>
                {ownDictionary.licensesCountLabelText}
              </TextComponent>
              <TextComponent>{monthReport.licensesCount}</TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>
                {ownDictionary.tariffAmountLabelText}
              </TextComponent>
              <TextComponent>
                {sharedDictionary.moneyAmountText(
                  monthReport.tariffAmount,
                  'USD'
                )}
              </TextComponent>
            </SmallTableRowComponent>
            <div
              style={{
                backgroundColor: '#F7F8FA',
                padding: '18px 24px',
                marginLeft: '-24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                width: 'calc(100% + 48px)',
                boxSizing: 'border-box',
              }}
            >
              <SmallTableRowComponent>
                <TextComponent>
                  {ownDictionary.monthIncomeLabelText}
                </TextComponent>
                <TextComponent>
                  {ownDictionary.incomeValueText(
                    monthReport.monthIncome,
                    monthReport.isFullMonth ? 100 : undefined
                  )}
                </TextComponent>
              </SmallTableRowComponent>
              {!monthReport.isFullMonth && (
                <SmallTableRowComponent>
                  <TextComponent>
                    {ownDictionary.periodIncomeLabelText(monthReport.period)}
                  </TextComponent>
                  <TextComponent>
                    {ownDictionary.incomeValueText(
                      monthReport.periodIncome,
                      monthReport.periodIncomePercent
                    )}
                  </TextComponent>
                </SmallTableRowComponent>
              )}
              <SmallTableRowComponent>
                <TextComponent weight="medium">
                  {ownDictionary.partnerIncomeLabelText}
                </TextComponent>
                <TextComponent weight="medium">
                  {ownDictionary.incomeValueText(
                    monthReport.partnerIncome,
                    monthReport.partnerIncomePercent
                  )}
                </TextComponent>
              </SmallTableRowComponent>
            </div>
            <SmallTableRowComponent>
              <TextComponent>
                {ownDictionary.debitStatusLabelText}
              </TextComponent>
              <TextComponent
                color={monthReport.debitIsPaid ? 'successful' : 'critical'}
              >
                {ownDictionary.debitStatusValueText(monthReport.debitIsPaid)}
              </TextComponent>
            </SmallTableRowComponent>
          </SmallTableWrapperComponent>
        </SidebarModalBlockComponent>
      ))}
    </>
  );
};
